module.exports = __webpack_public_path__ + "static/media/unni.9383f089.jpg";